var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-hover',{on:{"input":function($event){_vm.localValue = $event}}},[_vm._t("default",null,{"hover":_vm.localValue})],2)}
var staticRenderFns = []

export { render, staticRenderFns }